<template>
    <div class="row mb-3">
        <div class="col-sm-12 col-md-12">
            <ul class="warranty-submenu">
                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsRepairRequest'}"> Repair Requests </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsRepairActive'}"> Active Repairs </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsRepairClosed'}"> Closed Repairs </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RepairSubNav',
    components: {},
    data() {
        return {};
    }
};
</script>
